import React, { useEffect, useState } from 'react';
import { v4 } from "uuid";
import { useHistory, useParams } from "react-router-dom";
import MainLayout from '../MainLayout';
import { useDocument } from '../../context/documentInfoContex';
import { boardServices } from '../../api';
import SplashScreen from '../SplashScreen/SplashScreen';
import { useSplashExit } from '../SplashScreen/useSplashExit';
import { useCanvas } from '../../context/canvasContext';

const External = () => {
    const { id } = useParams();
    const history = useHistory();
    const { isExternal, setIsExternal, setIsReadOnly, setDocumentInfo } = useDocument();
    const { setUserInfo } = useCanvas();
    const [loading, setLoading] = useState(true);
    // Plays the splash's fade-out before the board replaces it.
    const { exiting, finishLoading } = useSplashExit(() => setLoading(false));

    useEffect(() => {
        (async () => {
            try {
                const result = await boardServices.verifyExternal(id);
                setIsExternal(true);
                setUserInfo({
                    userId: `external-${v4()}`,
                    email: 'N/A',
                    name: 'External User'
                });
                setIsReadOnly(true);
                setDocumentInfo(result?.data);
                finishLoading();
            } catch (error) {
                console.error("API error:", error);
                history.push('/unauthorized');
                setLoading(false);
            }
        })();
    }, [id]);

    return loading ? <SplashScreen exiting={exiting} /> : isExternal ? <MainLayout /> : null;

};

export default External;
